export const companySizes = [
  { value: 4, label: '1 - 9', id: 4 },
  { value: 3, label: '10 - 99', id: 3 },
  { value: 2, label: '100 - 249', id: 2 },
  { value: 1, label: '250+', id: 1 }
];
